"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowSelectModelBase = void 0;
const Entities_1 = require("../../Entities");
class ShowSelectModelBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (castPayload.callback === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload.callback;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'SHOW_SELECT_MODEL';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const castPayload = this.castPayloadV1(payload);
                this.action(castPayload);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.ShowSelectModelBase = ShowSelectModelBase;
